module.exports = __webpack_public_path__ + "img/image10@2x.bc545d17.png";